import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Responses/Requests
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveRateImportStatus } from "./rateImportStatusActions";

// Api's
import { rateImportStatusApi } from "@/main/api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getRateImportStatusSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(rateImportStatusApi.getDomain);

		if (response.data.result) {
			yield put(saveRateImportStatus(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveRateImportStatus(null, true, resultError.messagesDataError));
		}
	}
}
